import { Component, OnInit } from "@angular/core";

import { TweenMax, Linear, TweenLite, TimelineMax, Quad, Power4 } from "gsap";
import SmoothScrollbar from "smooth-scrollbar";
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  $window: any = $(window);
  $document = $(document);
  $body = $("body");
  $wrapper = $(".wrapper");
  $navbar = $(".navbar");
  $header = $(".header");
  scrollbar: any = null;
  scenes = [];
  screenHeight = this.$window.height();
  controller = {};
  isMobile = false;
  isIE = /MSIE|Trident/.test(window.navigator.userAgent);

  History: any[] = [
    {
      slideAttr: '0',
     year: '1967',
     name: 'D&H 1200 T: Nickel base alloy electrode conforming to the AWS classification ENICRFe2'
    },
    {
      slideAttr: "1",
      year: "1969",
      name: "D&H 45S special electrodes for welding of galvanizing tanks",
    },
    {
      slideAttr: "2",
      year: "1970",
      name:
        "Supratherme (SPL) for minus 50°C used in the fabrication of heavy water towers",
    },
    {
      slideAttr: "3",
      year: "1971",
      name:
        "D&H 1200 T: Nickel base alloy electrode conforming to the AWS classification ENICRFe2",
    },
    {
      slideAttr: "4",
      year: "1973",
      name:
        "Batox-D Basic coated Stainless Steel electrode conforming of the AWS classification E316L for liquid solution storage tanks",
    },
    {
      slideAttr: "5",
      year: "1974",
      name:
        "Cromotherme-9 AWS Classification E8018-B8 developed for and accepted by Engineers India Ltd, Haldia Refinery Project as the first indigenous electrode of its class",
    },
    {
      slideAttr: "6",
      year: "1976",
      name:
        "D&H 1200 T: Nickel base alloy electrode conforming to the AWS classification ENICRFe2",
    },
    {
      slideAttr: "7",
      year: "1978",
      name:
        "LoTherme range of low heat input electrode for repair and maintenance welding in several industries to conserve precious materials and components",
    },
    {
      slideAttr: "8",
      year: "1980",
      name:
        "Electrodes with extra low hydrogen (less than 3ml/100 gms) for welding under high relative humidity conditions",
    },
    {
      slideAttr: "9",
      year: "1981",
      name: " Corotherme electrodes for welding weathering steels",
    },
    {
      slideAttr: "10",
      year: "1992",
      name:
        "Tensal (SPL) an electrode conforming to E10018-D2 for welding of alloy steel castings",
    },
    {
      slideAttr: "11",
      year: "1993",
      name:
        "Supratherme (MOD) an electrode conforming to GS-8 specifications of EIL for H2S service. The weld metal possesses excellent resistance to SSCC and HIC",
    },
    {
      slideAttr: "12",
      year: "1998",
      name:
        "Cromotherme-9 (MOD) conforming to E9018-B9 classification for welding T91/P91 material",
    },
    {
      slideAttr: "13",
      year: "2000",
      name:
        "D&H 1260 an electrode conforming to ENiCrMo-6 for welding 9%Ni steel",
    },
    {
      slideAttr: "14",
      year: "2002",
      name:
        "D&H 444L-15 for welding ASTM-CA6NM casting and similar composition materials. The consumable is conforming to the E410NiMo-15 classification",
    },
    {
      slideAttr: "15",
      year: "2005",
      name:
        "Batox-B(N) a Stainless Steel electrode depositing 19Cr-10Ni-0.08N weld metal, which has excellent resistance to intergranular corrosion",
    },
    {
      slideAttr: "16",
      year: "2008",
      name:
        "Wear plate and complete full-fledged automated job work, the workshop established",
    },
    {
      slideAttr: "17",
      year: "2013",
      name:
        "Cromotherme-9H4R it is used for welding similar composition plates, pipes, forging and tubes. Typical applications include welding of A387 Gr.9 plate, A335 P9 Pipe, A217 C12 castings, A213 T9 tubes",
    },
    {
      slideAttr: "18",
      year: "2019",
      name:
        "Batox-HP4ONb is a basic coated electrode, specially designed to match heat resistant cast alloys. It is also suitable for the Nb free alloys and leaner high carbon Cr-Ni alloys such as HK40, HT40 and IN519. Weld metal is not prone to sigma phase embrittlement and the presence of eutectic and secondary carbides provide excellent hot strength and creep resistance in the typical service temperature range 900-1100°C. ",
    },
  ];

  constructor(private route: ActivatedRoute) {
    
  }

  fadeinAnimations() {
    const that = this;
    let [$window] = this.$window;

    $(".fadein-staggered").each(function () {
      var fadeinStaggeredScene = $window.ScrollMagic.Scene({
        triggerElement: that,
        triggerHook: 0.85,
        duration: 0,
        reverse: false,
      })
        .setTween(
          TweenMax.to($(that).find(".fadein"), 1, {
            autoAlpha: 1,
            x: "0px",
            ease: Quad.easeInOut,
            stagger: 0.2,
          })
        )
        .addTo(that.controller);
      that.scenes.push(fadeinStaggeredScene);
    });
  }

  parallaxAnimations() {
    const that = this;
    let [$window]: any = $(window);
    
    $(".parallax-me-center").each(function () {
      var direction = "down";
      var amount = 100;
      var thisElementHeight = $(this).height();

      if ($(this).data("parallax-direction")) {
        direction = $(this).data("parallax-direction");
      }

      if ($(this).data("parallax-amount")) {
        amount = $(this).data("parallax-amount");
      }

      var yfrom: any = "-" + amount;
      var yto: any = amount;

      if (direction == "up") {
        yfrom = amount;
        yto = "-" + amount;
      }

      var parallaxAnimationsScene = new $window.ScrollMagic.Scene(
        {
          triggerElement: this,
          triggerHook: "onCenter",
          offset: -((that.screenHeight - thisElementHeight) / 2 + amount),
          duration: that.screenHeight + amount * 2,
        }
      )
        .setTween(
          TweenMax.fromTo(
            this,
            1,
            {
              y: yfrom,
            },
            {
              y: yto,
              ease: Linear.easeNone,
            }
          )
        )
        .addTo(that.controller);
      that.scenes.push(parallaxAnimationsScene);
    });
  }

  headerTilt() {
    let [$window] = this.$window;
    if (!this.isMobile && !this.isIE) {
      $window.VanillaTilt.init(document.querySelectorAll(".tilt-me"), {
        max: 10,
        // max tilt rotation
        perspective: 1000,
        // perspective transform
        speed: 999,
        // enter/exit transition speed
        transition: true,
        // transition on enter/exit
        reset: true,
        // reset tilt on exit
        easing: "cubic-bezier(.03,.98,.52,.99)", // easing on enter/exit
      });
    }
  }

  aboutCompanyTimeline() {
    const that = this;
    let [$window] = this.$window;
    
    // draw the black lines
    $(".timel-line").each(function () {
      var blackLinesScene = new $window.ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: 0.7,
        duration: 0,
        reverse: false,
      })
        .setTween(
          TweenLite.from($(this).find("span"), 0.5, {
            height: "0",
            ease: Quad.easeInOut,
          })
        )
        .addTo(that.controller);
      that.scenes.push(blackLinesScene);
    }); // smooth scroll to anchor link (in center of screen)

    $("#timelineNav .nav-link").on("click", function (event) {
      event.preventDefault();
      var thisHref = $(this).attr("href");
      var targetTop = $(thisHref).offset().top + 16;
      var targetHeight = $(thisHref).parent().height();
      var targetWidth = $(thisHref).parent().width();
      var screenHeight = $(window).height();
      var screenWidth = $(window).width();
      var ypos = (screenHeight - targetHeight) / 2;
      var xpos = (screenWidth - targetWidth) / 2;
      
      that.scrollbar &&
        that.scrollbar.scrollIntoView(
          document.getElementById(thisHref.substring(1)),
          {
            offsetTop: ypos,
            offsetLeft: xpos
          }
        );
    }); // fade nav in and out
    if ($(".about-company-page-main").length) {
      var navFadeScene = new $window.ScrollMagic.Scene({
        triggerElement: ".about-company-page-main",
        triggerHook: "onLeave",
        reverse: true,
      })
        .setClassToggle("#timelineNav", "active")
        .addTo(that.controller);
      that.scenes.push(navFadeScene);
      
      var navFadeSceneHide = new $window.ScrollMagic.Scene({
        triggerElement: ".aboutus-footer",
        triggerHook: 1
      })
        .setClassToggle("#timelineNav", "hidden")
        .addTo(that.controller);
      that.scenes.push(navFadeSceneHide);

      var hideHeader = new $window.ScrollMagic.Scene({
        triggerElement: ".about-company-page-main",
        triggerHook: "onLeave",
        reverse: true,
      })
        .setClassToggle("#mainHeader", "hidden")
        .addTo(that.controller);
      that.scenes.push(hideHeader);
    } // highlight each nav element on scroll

    $(".timel-date").each(function () {
      var navHighlightScene = new $window.ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: "onCenter",
        duration: $(this).height() + 160,
        offset: -80,
        reverse: true,
      })
        .setClassToggle(
          "#navLink-" + $(this).find(".anchor").attr("id"),
          "active"
        )
        .addTo(that.controller);
      
      that.scenes.push(navHighlightScene);
    });
  }

  smoothScrollbar() {
    const that = this;
    let [$window] = this.$window;
    this.scrollbar = SmoothScrollbar.init(document.querySelector(".wrapper")); // try to get ScrollMagic to work nicely with Smooth Scrollbar. ref: https://github.com/janpaepke/ScrollMagic/issues/652

    this.scrollbar.addListener(function (status) {
      that.scenes &&
        that.scenes.forEach(function (scene) {
          scene.refresh();
        });
    });
  }

  responsiveClasses() {
    let jRespond = this.$window[0].jRespond;
    let [$body]: any = this.$body;

    if (typeof jRespond === "undefined") {
      console.log("responsiveClasses: jRespond not Defined.");
      return true;
    }

    var jRes = jRespond([
      {
        label: "smallest",
        enter: 0,
        exit: 575,
      },
      {
        label: "handheld",
        enter: 576,
        exit: 767,
      },
      {
        label: "tablet",
        enter: 768,
        exit: 991,
      },
      {
        label: "laptop",
        enter: 992,
        exit: 1199,
      },
      {
        label: "desktop",
        enter: 1200,
        exit: 10000,
      },
    ]);
    
    jRes.addFunc([
      {
        breakpoint: "desktop",
        enter: function enter() {
          $body.classList.add("device-xl");
        },
        exit: function exit() {
          $body.classList.remove("device-xl");
        },
      },
      {
        breakpoint: "laptop",
        enter: function enter() {
          $body.classList.add("device-lg");
        },
        exit: function exit() {
          $body.classList.remove("device-lg");
        },
      },
      {
        breakpoint: "tablet",
        enter: function enter() {
          $body.classList.add("device-md");
        },
        exit: function exit() {
          $body.classList.remove("device-md");
        },
      },
      {
        breakpoint: "handheld",
        enter: function enter() {
          $body.classList.add("device-sm");
        },
        exit: function exit() {
          $body.classList.remove("device-sm");
        },
      },
      {
        breakpoint: "smallest",
        enter: function enter() {
          $body.classList.add("device-xs");
        },
        exit: function exit() {
          $body.classList.remove("device-xs");
        },
      },
    ]);
  }

  pageloadAnimations() {
    let $wrapper = $(".wrapper");
    let $header = this.$header;
    //window.onload = function() {
    var masterTl = new TimelineMax(); // fade in the page wrapper

    if ($wrapper.hasClass("wrapper-fadein")) {
      masterTl.to($wrapper, 1, {
        autoAlpha: 1,
        ease: Quad.easeInOut,
      });
    } // create header content animations

    if ($header.hasClass("header-home")) {
      var headerTl = new TimelineMax();
      headerTl
        .from($header.find(".line-above").find("span"), 0.4, {
          height: "0",
          ease: Quad.easeInOut,
        })
        .from(
          $header.find(".header-text"),
          0.6,
          {
            autoAlpha: 0,
            y: "10px",
            ease: Power4.easeInOut,
          },
          0.5
        )
        .from(
          $header.find(".line-below").find("span"),
          0.4,
          {
            height: "0",
            ease: Quad.easeInOut,
          },
          0.5
        );
    } else if ($header.hasClass("header-centered")) {
      var headerTl = new TimelineMax();
      headerTl
        .from($header.find(".h6"), 0.4, {
          autoAlpha: 0,
          y: "-10px",
          ease: Power4.easeInOut,
        })
        .from(
          $header.find("h1"),
          0.6,
          {
            autoAlpha: 0,
            y: "10px",
            ease: Power4.easeInOut,
          },
          0.5
        )
        .from(
          $header.find(".line-below").find("span"),
          0.4,
          {
            height: "0",
            ease: Quad.easeInOut,
          },
          0.5
        );
    } else if ($(".header-content").length) {
      var headerTl = new TimelineMax();
      headerTl.from(
        $(".header-content").children(),
        1,
        {
          autoAlpha: 0,
          x: "-20px",
          ease: Power4.easeInOut,
          clearProps: "all",
        },
        0.2
      );
    } // add header content animations to master timeline

    if (headerTl) {
      masterTl.add(headerTl);
    } //}
  }

  ngOnInit(): void {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4)
      )
    ) {
      this.isMobile = true;
    }

    const that = this;
    let [$window] = that.$window;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    $(document).ready(function () {
      that.controller = new $window.ScrollMagic.Controller({
        container: ".wrapper",
        refreshInterval: 0,
      });
      that.responsiveClasses();
      that.fadeinAnimations();
      that.parallaxAnimations();
      that.headerTilt();
      that.pageloadAnimations();
      that.aboutCompanyTimeline();
      that.smoothScrollbar();
      var thisHref = that.route.snapshot.queryParamMap.get('year');
      if(thisHref){
        thisHref = '#'+ thisHref
      var targetTop = $(thisHref).offset()?.top + 16;
      var targetHeight = $(thisHref).parent().height();
      var targetWidth = $(thisHref).parent().width();
      var screenHeight = $(window).height();
      var screenWidth = $(window).width();
      var ypos = (screenHeight - targetHeight) / 2;
      var xpos = (screenWidth - targetWidth) / 2;
      
      that.scrollbar &&
        that.scrollbar.scrollIntoView(
          document.getElementById(thisHref.substring(1)),
          {
            offsetTop: ypos,
            offsetLeft: xpos
          }
        );
    }
    });
  }
}
